import { useGridRootProps as useCommunityGridRootProps } from '@mui/x-data-grid';
export const useGridRootProps = useCommunityGridRootProps;